






import { Component, Prop, Vue } from 'vue-property-decorator';
import { isNullOrWhitespace } from '../../helper/isNullOrWhitespace';

@Component({})
export default class DynamicVisibilityForValuesContainer extends Vue {
    @Prop(String)
    public idOfInput!: string;
    @Prop(Array)
    public visibleForValues!: string[];

    private showSlotContent: boolean = false;
    private inputElement: HTMLInputElement | null = null;

    protected mounted(): void {
        this.inputElement = document.getElementById(this.idOfInput) as HTMLInputElement;
        if (this.inputElement) {
            this.inputElement.addEventListener('change', this.toggleSlotContentVisibility);
            this.toggleSlotContentVisibility();
        }
    }

    protected beforeDestroy(): void {
        if (this.inputElement) {
            this.inputElement.removeEventListener('change', this.toggleSlotContentVisibility);
        }
    }

    private toggleSlotContentVisibility(): void {
        if (this.inputElement) {
            const value = this.inputElement.value;
            this.showSlotContent = !isNullOrWhitespace(value) && this.visibleForValues.includes(value);
        }
    }
}
